import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import "core-js/modules/es.function.name.js";
import Vue from 'vue';
import { createImage } from '~image';
import NuxtImg from '~image/components/nuxt-img.vue';
import NuxtPicture from '~image/components/nuxt-picture.vue';
import * as staticRuntime$3ad3 from '/bravado/frontend/node_modules/@nuxt/image/dist/runtime/providers/static.js';
import * as cloudinaryRuntime$1cf1 from '/bravado/frontend/node_modules/@nuxt/image/dist/runtime/providers/cloudinary.js';
import * as localRuntime$49e6 from '/bravado/frontend/nuxtconfig/image/localProvider.ts';
var imageOptions = {
  "screens": {
    "xs": 320,
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "xxl": 1536,
    "2xl": 1536
  },
  "presets": {
    "face": {
      "modifiers": {
        "gravity": "face"
      }
    },
    "comment": {
      "modifiers": {
        "ar": "700:258",
        "height": 258
      }
    },
    "expanded-comment": {
      "modifiers": {
        "ar": "700:258",
        "c": "limit"
      }
    },
    "avatar": {
      "modifiers": {
        "effect": "sharpen:100",
        "quality": "auto:best",
        "c": "fill"
      }
    }
  },
  "provider": "cloudinary",
  "domains": [],
  "alias": {},
  "density": ""
};
imageOptions.providers = _defineProperty(_defineProperty(_defineProperty({}, 'static', {
  provider: staticRuntime$3ad3,
  defaults: {}
}), 'cloudinary', {
  provider: cloudinaryRuntime$1cf1,
  defaults: {
    "baseURL": "https://res.cloudinary.com/bravado/image/fetch/",
    "modifiers": {
      "c": "fit"
    }
  }
}), 'local', {
  provider: localRuntime$49e6,
  defaults: {
    "baseURL": ""
  }
});
Vue.component(NuxtImg.name, NuxtImg);
Vue.component(NuxtPicture.name, NuxtPicture);
Vue.component('NImg', NuxtImg);
Vue.component('NPicture', NuxtPicture);
export default function (nuxtContext, inject) {
  var $img = createImage(imageOptions, nuxtContext);
  if (process.static && process.server) {
    nuxtContext.beforeNuxtRender(function (_ref) {
      var nuxtState = _ref.nuxtState;
      var ssrData = nuxtState.data[0] || {};
      ssrData._img = nuxtState._img || {};
    });
  }
  inject('img', $img);
}